<template>
	<Grid>
		<GridItem v-for="icon in icons" :key="icon" :icon="icon" :text="icon" />
	</Grid>
</template>

<script>
import { Grid, GridItem } from 'vant';
import { ICONS } from './icons';

export default {
	components: {
		Grid, GridItem,
	},
	computed: {
		icons: function () {
			return ICONS;
		}
	},
}
</script>
